




























import { ListItem } from '@/types/index';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component
export class SearchItem extends Vue {
    private opened: boolean = false;
    private hello: any = {};
    @Prop() private details!: ListItem;
    @Emit('search:tag')
    private searchTag(feature: string) {
        return feature;
    }
    private async onClick() {
        this.opened = ! this.opened;
    }
}
export default SearchItem;
